import MuiSwitch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import React, { ChangeEvent, FC, ReactNode } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { StyledSwitchContainer } from "./styled";

type Props = {
  label?: ReactNode;
  value: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

const Switch: FC<Props> = (props) => {
  const handleChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    props.onChange(checked);
  };

  return (
    <FlexCenter>
      <StyledSwitchContainer>
        <MuiSwitch
          checked={props.value}
          onChange={handleChange}
          disabled={props.disabled}
        />
      </StyledSwitchContainer>
      <Typography variant="bodyMSemiBold">{props.label}</Typography>
    </FlexCenter>
  );
};

export default Switch;
